var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportExcelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10193",
    "data-name": "Group 10193",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3957",
    "data-name": "Path 3957",
    d: "M0,0H19V19H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3958",
    "data-name": "Path 3958",
    d: "M2.68,2.5l9.951-1.421a.4.4,0,0,1,.452.392v16.5a.4.4,0,0,1-.451.392L2.679,16.947A.792.792,0,0,1,2,16.163V3.286a.792.792,0,0,1,.68-.784Zm.9,1.471v11.5L11.5,16.607V2.842ZM13.875,15.266H16.25V4.183H13.875V2.6h3.167a.792.792,0,0,1,.792.792V16.058a.792.792,0,0,1-.792.792H13.875ZM8.491,9.724l2.217,3.167h-1.9l-1.267-1.81-1.267,1.81h-1.9L6.591,9.724,4.375,6.558h1.9l1.267,1.81,1.267-1.81h1.9Z",
    transform: "translate(-0.416 -0.224)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportExcelIcon);
export default __webpack_public_path__ + "static/media/ImportExcelIcon.15eeaa0fd74973ac5e3862a55b44134a.svg";
export { ForwardRef as ReactComponent };